import React, { FC } from 'react';
import pluralize from 'pluralize';
import { EventDTO } from '@atlassiansox/phobos-client-ts';

import {
  BREACH_COLOR,
  BURN_COLOR,
  flex,
  flexDirectionColumn,
  spaceGapMinimum,
  BREACH_LIGHT_COLOR,
  BURN_LIGHT_COLOR,
  INVERSE_COLOR,
  spaceTopComfortable,
} from '@/styles';

import { getEventTypes } from '../../utils';

import EventsBadge from './events-badge';

type EventsListProps = {
  events: EventDTO[];
};

type EventsListItem = [Array<EventDTO>, boolean, string, string, string, boolean, boolean];

const EventsList: FC<EventsListProps> = ({ events: allEvents }) => {
  if (allEvents.length === 0) {
    return <></>;
  }

  const {
    breachEvents,
    burnEvents,
    sfxBreachEvents,
    sfxBurnEvents,
    lowTrafficBreachEvents,
    lowTrafficBurnEvents,
    lowTrafficSFxBreachEvents,
    lowTrafficSFxBurnEvents,
  } = getEventTypes(allEvents);

  const EventNodes: EventsListItem[] = [
    [
      breachEvents,
      true,
      BREACH_COLOR,
      INVERSE_COLOR,
      `SLO ${pluralize('Breach', breachEvents.length)}`,
      false,
      false,
    ],
    [
      lowTrafficBreachEvents,
      false,
      BREACH_LIGHT_COLOR,
      BREACH_COLOR,
      `SLO ${pluralize('Breach', lowTrafficBreachEvents.length)}`,
      false,
      true,
    ],
    [
      burnEvents,
      true,
      BURN_COLOR,
      INVERSE_COLOR,
      `Error Budget ${pluralize('Burn', burnEvents.length)}`,
      false,
      false,
    ],
    [
      lowTrafficBurnEvents,
      false,
      BURN_LIGHT_COLOR,
      BURN_COLOR,
      `Error Budget ${pluralize('Burn', lowTrafficBurnEvents.length)}`,
      false,
      true,
    ],
    [
      sfxBreachEvents,
      true,
      BREACH_COLOR,
      INVERSE_COLOR,
      `Breach ${pluralize('Alert', sfxBreachEvents.length)}`,
      true,
      false,
    ],
    [
      lowTrafficSFxBreachEvents,
      false,
      BREACH_LIGHT_COLOR,
      BREACH_COLOR,
      `Breach ${pluralize('Alert', lowTrafficSFxBreachEvents.length)}`,
      true,
      true,
    ],
    [
      sfxBurnEvents,
      true,
      BURN_COLOR,
      INVERSE_COLOR,
      `Burn ${pluralize('Alert', sfxBurnEvents.length)}`,
      true,
      false,
    ],
    [
      lowTrafficSFxBurnEvents,
      false,
      BURN_LIGHT_COLOR,
      BURN_COLOR,
      `Burn ${pluralize('Alert', lowTrafficSFxBurnEvents.length)}`,
      true,
      true,
    ],
  ];

  return (
    <div css={[spaceGapMinimum, flex, flexDirectionColumn, spaceTopComfortable]}>
      {EventNodes.filter(([events]) => !!events.length).map(
        ([events, isBold, bgColor, textColor, caption, useWithSfxIcon, useLowTrafficTag]) => (
          <EventsBadge
            key={events[0].publicId}
            count={events.length}
            backgroundColor={bgColor}
            textColor={textColor}
            caption={caption}
            useWithSfxIcon={useWithSfxIcon}
            useLowTrafficTag={useLowTrafficTag}
            isBold={isBold}
          />
        )
      )}
    </div>
  );
};

export default EventsList;
